<template>
  <div class="content">
    <h1 class="has-text-centered">Netzwerktechnik</h1>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-operating-systems' }" class="inherited">
                  <div class="p-2">Betriebssysteme</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-network-security' }" class="inherited">
                  <div class="p-2">Netzwerksicherheit</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-data-storage' }" class="inherited">
                  <div class="p-2">Datenspeicherung</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-network-debugging' }" class="inherited">
                  <div class="p-2">Fehlersuche in Netzwerken</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-digital-signature' }" class="inherited">
                  <div class="p-2">Digitale Signatur</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-wlan' }" class="inherited">
                  <div class="p-2">WLAN</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-network-access-methods' }" class="inherited">
                  <div class="p-2">Netzwerk Zugriffsverfahren</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-http-protocol' }" class="inherited">
                  <div class="p-2">HTTP Protokoll</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-ftp-protocol' }" class="inherited">
                  <div class="p-2">FTP Protokoll</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-osi-model' }" class="inherited">
                  <div class="p-2">OSI-Modell</div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-network-management' }" class="inherited">
                  <div class="p-2">Netzwerkmanagement</div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <h2 class="has-text-centered">Häufige Fragen</h2>
    <div class="box">
      <FAQs :faqs="faqs" />
    </div>
  </div>
</template>

<script>
import FAQs from '@/components/FAQs.vue'

export default {
  name: 'theory-network-engineering',
  components: {
    FAQs
  },
  metaInfo: {
    title: 'Netzwerktechnik | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Lorem Ipsum'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Netzwerktechnik', route: 'start' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Was sind die Aufgaben der Netzwerktechnik?',
          answer: 'NetzwerktechnikerInnen planen und warten Netzwerke bestehend aus Computern, Terminals und Peripheriegeräten. Dazu gehören auch Netzwerkgeräte wie Router oder Hubs/Switches.'
        },
        {
          question: 'Was ist eine Netzwerkarchitektur?',
          answer: 'Eine Netzwerkarchitektur beschreibt die verwendete Topologie, Verkabelung und die verwendete Hard-/Software. Je nach Dimension des Netzwerks unterscheidet man zwischen GAN, WAN, MAN oder LAN.'
        },
        {
          question: 'Was sind Netzwerkprotokolle?',
          answer: 'Systeme in Netzwerken kommunizieren über Netzwerkprotokolle. Ein Protokoll legt fest nach welchen Regeln die Kommunikation zwischen zwei oder mehr Systemen ablaufen muss. Es wird definiert wie ein Austausch starten muss, wie er abläuft und auch wie er beendet wird. Ein sehr bekanntes Beispiel ist HTTP (Hypertext Transfer Protocol).'
        }
      ]
    }
  }
}
</script>
